import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getViewInvoice = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/download-invoice/png',
    headers:  getHeaders(),
  });
};

export const getViewInvoice2 = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/download-invoice/html',
    headers:  getHeaders(),
  });
};

export const getViewInvoice3 = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v2/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/download-invoice/html',
    headers:  getHeaders(),
  });
};

export const getViewInvoiceImage = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/download-invoice/png/image',
    headers:  getHeaders(),
  });
};

export const getInvoiceText = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/download-invoice-text',
    headers:  getHeaders(),
  });
};


export const getViewInvoiceWebVersion = (id, storeId, orderId,invoiceType) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/download-invoice-new/pdf/' + invoiceType,
      
    headers:  getHeaders(),
  });
};

export const getViewInvoiceWebVersionHtml = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/download-invoice-normal/html/mini',
      
    headers:  getHeaders(),
  });
};

export const getRegenerateInvoice = (storeId, storeCustomerId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      storeCustomerId +
      '/order/' +
      orderId +
      '/regenerate-invoice',
    headers:  getHeaders(),
  });
};

export const getPOSInvoiceImage = (storeCustomerId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/download-invoice/' +
      storeCustomerId +
      '/' +
      orderId +
      '/web',
    headers: getHeaders(),
  });
};

// https://dhobicart.in/store/api/secure/v1/store/1/store-customer/1/order/2314/download-invoice-new/png/web'
// '/download-invoice/html/web',
// '/download-invoice/png/web',
// '/download-invoice/pdf/web',
// '/download-invoice/pdf/[a4, a5, mini]',